// extracted by mini-css-extract-plugin
export var actions = "_lj-d";
export var benefitCard = "_lj-a";
export var benefitIcon = "_lj-b";
export var benefitLabel = "_lj-c";
export var benefits = "_lj-9";
export var bodyText = "_lj-8";
export var closeButton = "_lj-2";
export var content = "_lj-3";
export var eyebrow = "_lj-4";
export var heading = "_lj-5";
export var image = "_lj-f";
export var imagePanel = "_lj-e";
export var modal = "_lj-0";
export var shell = "_lj-1";
export var title = "_lj-6";
export var titleOffer = "_lj-7";